// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");

function ShortTextDefaultForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var shortText = props.shortText;
  var handleOnchange = function ($$event) {
    var value = $$event.target.value;
    var firstChar = value[0];
    var check = Belt_Array.getBy([
          "<",
          "=",
          "+",
          "-",
          "@"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined || value.trim() === "") {
      return Curry._1(onChange, ShortText$ReactHooksTemplate.setAnswer(shortText, undefined));
    } else {
      return Curry._1(onChange, ShortText$ReactHooksTemplate.setAnswer(shortText, value));
    }
  };
  var rawText = ShortText$ReactHooksTemplate.getTextTranslation(shortText, SurveyLanguage$ReactHooksTemplate.name(language));
  var rawDescription = ShortText$ReactHooksTemplate.getDescriptionTranslation(shortText, SurveyLanguage$ReactHooksTemplate.name(language));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawText, substitutionVariables) + (
    mandatory ? " *" : ""
  );
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: titleHtml
                              }
                            }),
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("input", {
                            className: "h-48-px py-2 px-4 bg-alicebluepurple focus:border-gray-600 text-xs w-full",
                            maxLength: 500,
                            placeholder: ShortText$ReactHooksTemplate.getPlaceholderTranslation(shortText, SurveyLanguage$ReactHooksTemplate.name(language)),
                            type: "text",
                            value: ShortText$ReactHooksTemplate.answerToString(shortText),
                            onChange: handleOnchange
                          }),
                      className: "flex w-full pb-6"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = ShortTextDefaultForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
